module.exports = __webpack_public_path__ + "media/images/matchmaking-banner-a7b3c655ef59438e95e05f0dc43f4eba.png";